export enum DumpTruckFields {
    Client = 'cliente',
    Address = 'direccion',
    Observations = 'observaciones',
    Amount = 'importe',
    DeliveryNote = 'remito',
    Invoice = 'factura',

    TypeCode = 'codTipo',
    TypeDescription = 'descTipo',

    StatusCode = 'codEstado',
    StatusDescription = 'descEstado',

    CreationDate = 'fechaAlta',
    DeliveryDate = 'fechaEntrega',
    RemovalDate = 'fechaRetiro',

    CreatedByUserId = 'idUsuarioAlta',
    Quantity = 'cantidad',
}

export enum DumpTruckFilterFields {
    Client = 'cliente',
    Address = 'direccion',
    DeliveryNote = 'remito',
    Invoice = 'factura',

    DeliveryDateStart = 'fechaEntregaDesde',
    DeliveryDateEnd = 'fechaEntregaHasta',
    RemovalDateStart = 'fechaRetiroDesde',
    RemovalDateEnd = 'fechaRetiroHasta',

    TypeCodeList = 'tipos',
    StatusCodeList = 'estados',
    IsBilled = 'facturado',
}

export enum DumpTruckSummaryFields {
    ActiveQuantity = 'cantidadActivos',
    AvailableQuantity = 'cantidadDisponibles',
    DeliveredCurrentMonth = 'entregadosMesActual',
    DeliveredPreviousMonth = 'entregadosMesAnterior',
    UnbilledQuantity = 'cantidadSinFacturar'

}
